import React from 'react';
import styles from './subscriptionPlaced.module.css';
import conformImg from '../../assets/images/undraw_order_confirmed_aaw7.svg';
import {StyledButton} from './styledMaterialComponents';

const subscriptionPlaced = () => (
    <div className={styles.orderPlaced}>
        <div className={styles.confomation}>
            <img src={conformImg} alt="conformed" />
            <h2>Gratulacje!</h2>
            <p>
                Przyjeliśmy twoje zamówienie. Propozycja Twojej mieszanki
                zostanie dostarczona na Twój adres email w ciągu najbliższej
                doby.
            </p>
            <StyledButton
                variant="contained"
                onClick={e => {
                    e.preventDefault();
                    window.location.href = 'https://herbzy.space/';
                }}
                color="primary"
                size="large">
                Wróć do strony głównej
            </StyledButton>
        </div>
    </div>
);

export default subscriptionPlaced;
